import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0302e69a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pcard" }
const _hoisted_2 = {
  key: 0,
  class: "latest"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Latest Release", -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "sub-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.xpkg.latest)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            class: "clear-cache",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearCache()))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.xpkg.fileName), 1),
    _createElementVNode("p", _hoisted_5, " v" + _toDisplayString(_ctx.xpkg.version) + " | " + _toDisplayString(_ctx.$filters.formatSize(_ctx.xpkg.sizeBytes)) + " | " + _toDisplayString(_ctx.$filters.timeSpan(_ctx.xpkg.releaseDate)), 1),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download(_ctx.xpkg.version))),
      class: _normalizeClass(["btn", {'btn-success': !_ctx.xpkg.latest, 'btn-danger': _ctx.xpkg.latest }])
    }, "Download v" + _toDisplayString(_ctx.xpkg.version), 3),
    _createElementVNode("img", {
      src: "images/logo.png",
      class: "logo",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLink('https://archistar.ai')))
    }),
    _createElementVNode("img", {
      src: "images/rhino.png",
      class: "logo rhino-logo",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLink('https://www.rhino3d.com')))
    })
  ]))
}